<div #root class="online-payment-announcement" tabindex="-1">
  <div class="online-payment-announcement__header">
    <button
      pButton
      type="button"
      class="p-button-text online-payment-announcement__close"
      [attr.aria-label]="'COMMON.CLOSE' | transloco"
      (click)="close(action.Close)"
    >
      <i
        class="pi pi-times online-payment-announcement__close-icon"
        aria-hidden="true"
      ></i>
    </button>
  </div>

  <img
    class="online-payment-announcement__illustration"
    [src]="illustration.src"
    [width]="illustration.width"
    [height]="illustration.height"
    alt=""
  />

  <p [id]="messageId" class="online-payment-announcement__message">
    {{ 'ONLINE_PAYMENT_ANNOUNCEMENT.MESSAGE' | transloco }}
  </p>

  <div class="online-payment-announcement__actions">
    <button
      pButton
      type="button"
      class="p-button-text online-payment-announcement__button online-payment-announcement__button--secondary"
      (click)="close(action.Close)"
    >
      <span class="p-button-label online-payment-announcement__button-label">{{
        'COMMON.CLOSE' | transloco
      }}</span>
    </button>

    <button
      pButton
      type="button"
      class="online-payment-announcement__button online-payment-announcement__button--primary"
      (click)="close(action.LearnMore)"
    >
      <span class="p-button-label online-payment-announcement__button-label">{{
        'ONLINE_PAYMENT_ANNOUNCEMENT.LEARN_MORE' | transloco
      }}</span>
    </button>
  </div>
</div>
